import type { Stance } from "./types";

/** Values of the legacy AgendaItemDisposition enum stored in RegistrationOptions. */
const STANCE_BY_CONFIGURED_VALUE: Record<number, Stance> = {
  0: "neutral",
  1: "for",
  2: "against"
};

/** Display order, independent of the order the meeting stored them in. */
const DISPLAY_ORDER: Stance[] = ["for", "against", "neutral"];

export const ALL_STANCES: Stance[] = DISPLAY_ORDER;

export function offeredStances(
  configuredValues: readonly number[] | null | undefined
): Stance[] {
  if (!configuredValues || configuredValues.length === 0) return DISPLAY_ORDER;

  const configured = new Set(
    configuredValues
      .map((value) => STANCE_BY_CONFIGURED_VALUE[value])
      .filter((stance): stance is Stance => stance !== undefined)
  );

  if (configured.size === 0) return DISPLAY_ORDER;

  return DISPLAY_ORDER.filter((stance) => configured.has(stance));
}
